const STORAGE_KEY = "cardora:authReturnTo";
export function safeReturnTo(value, fallback = "/binder") {
  if (typeof value !== "string" || value.length > 2048 || !value.startsWith("/") || value.startsWith("//") || value.includes("\\") || Array.from(value).some(char => char.charCodeAt(0) <= 32)) return fallback;
  try {
    const url = new URL(value, "https://cardora.invalid");
    if (url.origin !== "https://cardora.invalid" || !/^\/(binder(?:\/|$)|u\/|trades(?:\/|$)|stores\/register$|feed$)/.test(url.pathname)) return fallback;
    return url.pathname + url.search + url.hash;
  } catch { return fallback; }
}
export function rememberReturnTo(value) {
  const path = safeReturnTo(value);
  sessionStorage.setItem(STORAGE_KEY, path);
  return path;
}
export function authReturnTo(value, fallback = "/binder") {
  return safeReturnTo(value || sessionStorage.getItem(STORAGE_KEY), fallback);
}
